(() => {
  const DEBUG = true; // mets false si tu veux couper les logs
  const log = (...a) => DEBUG && console.log('[CleanCount]', ...a);
  const SECTION_HANDLE = 'cart-clean-count'; // correspond au fichier .liquid
  const BADGE_SELECTOR = '#cart-count';      // ton <span id="cart-count">

  // -- Récupère la valeur calculée côté Liquid via render de section
  async function fetchCleanCount() {
    const url = `/?sections=${SECTION_HANDLE}&_=${Date.now()}`;

    const res = await fetch(url, { credentials: 'same-origin', headers: { 'Cache-Control': 'no-store' } });
    if (!res.ok) { log('fetch FAIL', res.status); return null; }
    const json = await res.json();
    const html = json[SECTION_HANDLE] || '';
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const span = tmp.querySelector('[data-clean-cart-count]');
    if (!span) { log('span [data-clean-cart-count] introuvable'); return null; }
    const n = parseInt(span.getAttribute('data-clean-cart-count') || '0', 10);
    return Number.isFinite(n) ? n : 0;
  }

  function updateBadge(count) {
    const badge = document.querySelector(BADGE_SELECTOR);
    if (!badge) { log('badge introuvable ->', BADGE_SELECTOR); return; }
    const before = (badge.textContent || '').trim();
    badge.textContent = String(count);
    badge.style.display = count > 0 ? 'block' : 'none';
  }

  let inflight = false;
  async function refresh(reason = '') {
    if (inflight) { return; }
    inflight = true;
    try {
      const n = await fetchCleanCount();
      if (n !== null) updateBadge(n);
    } catch (e) {
      console.error('[CleanCount] refresh error', e);
    } finally {
      inflight = false;
    }
  }

  function hookEvents() {
    // 1) Intercepter les appels Ajax Shopify /cart/*
    const _fetch = window.fetch;
    window.fetch = async (...args) => {
      const resp = await _fetch(...args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
        const method = (args[1]?.method || 'GET').toUpperCase();
        if (/\/cart\/(add|change|update)(\.js)?/i.test(url) && method !== 'GET') {
          setTimeout(() => refresh('fetch ' + url), 80);
        }
      } catch (e) { log('fetch intercept err', e); }
      return resp;
    };

    // 2) Soumission directe d’un form /cart/add (certains thèmes)
    document.addEventListener('submit', (ev) => {
      const form = ev.target;
      if (form instanceof HTMLFormElement) {
        const action = (form.getAttribute('action') || '').toLowerCase();
        if (action.startsWith('/cart/add')) {
          setTimeout(() => refresh('form /cart/add'), 250);
        }
      }
    }, true);

    // 3) Événements de thème/cart courants
    ['cart:refresh','cart:updated','cart:update','cart:change','line-item:change','ajaxProduct:added','product:added']
      .forEach(evt => document.addEventListener(evt, () => refresh('event ' + evt), true));

    // 4) Rechargement de sections (header/cart drawer)
    document.addEventListener('shopify:section:load', (e) => {
      refresh('section:load');
    });

    // 5) Retour de page (BFCache) & retour onglet
    window.addEventListener('pageshow', () => refresh('pageshow'));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh('tab visible'); });

    // 6) Si le header est remplacé dynamiquement, on surveille l’arrivée du badge
    const root = document.querySelector('header') || document.body;
    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === 'childList') {
          if ([...m.addedNodes].some(n => n.nodeType === 1 && n.querySelector?.(BADGE_SELECTOR))) {
            refresh('mutation');
            break;
          }
        }
      }
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    hookEvents();
    refresh('DOMContentLoaded');
  });
})();
